import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { minNumber, maxNumber, emptyOrPattern } from '@parchment/validation-utils';
import ComposedTextField from '../ComposedField/ComposedTextField';
import roundToDenominator from '../../utils/roundToDenominator';
export const minValidator = min => ({
  message: `Please enter a year greater than or equal to ${min}`,
  callback: value => minNumber(min, Number(value))
});
export const maxValidator = max => ({
  message: `Please enter a year less than or equal to ${max}`,
  callback: value => maxNumber(max, Number(value))
});
export const numberValidator = {
  message: 'Please enter a valid year',
  callback: emptyOrPattern.bind(null, /^[1-9]\d*$/)
};

// creates a set of validators...
// one that validates the value is numeric
// IF we have a min value, one that validates it is greater than or equal to the min value
// IF we have a max value, one that validates it is less than or equal to the max value
export const defaultValidators = (min, max) => [numberValidator, isNaN(min) ? null : minValidator(min), isNaN(max) ? null : maxValidator(max)].filter(validator => validator);
const CURRENT_YEAR = new Date().getFullYear();
export default function Year(_ref) {
  let {
    name = 'year',
    label = 'Year',
    type = 'number',
    maxLength = 4,
    relativeMin = undefined,
    roundMinMethod = 'floor',
    roundMinDenominator = 1,
    relativeMax = undefined,
    roundMaxMethod = 'ceil',
    roundMaxDenominator = 1,
    min = typeof relativeMin !== 'undefined' ? roundToDenominator(CURRENT_YEAR + relativeMin, roundMinDenominator, roundMinMethod) : undefined,
    max = typeof relativeMax !== 'undefined' ? roundToDenominator(CURRENT_YEAR + relativeMax, roundMaxDenominator, roundMaxMethod) : undefined,
    validators = defaultValidators(Number(min), Number(max)),
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, props, {
    name: name,
    label: label,
    type: type,
    min: min,
    max: max,
    validators: validators,
    maxLength: maxLength
  }));
}